import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';
import ManualOrderForm from './ManualOrderForm';
import OrderEditForm from './OrderEditForm';
import { z6ManualOrders } from './z6flag';

const API = '/api';

type Props = { onBack: () => void };

const MARK_COLORS = ['#ef4444', '#f59e0b', '#22c55e', '#3b82f6', '#a855f7', '#6b7280'];

const s: any = {
  btn: { padding: '6px 12px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', color: '#374151', fontSize: 13, cursor: 'pointer', fontWeight: 500 },
  btnPrimary: { padding: '6px 14px', borderRadius: 8, border: '1px solid #1d4ed8', background: '#1d4ed8', color: '#fff', fontSize: 13, cursor: 'pointer', fontWeight: 600 },
  input: { border: '1px solid #d1d5db', borderRadius: 8, padding: '6px 10px', fontSize: 13, fontFamily: 'inherit', outline: 'none', background: '#fff', boxSizing: 'border-box' },
  select: { border: '1px solid #d1d5db', borderRadius: 8, padding: '6px 8px', fontSize: 13, background: '#fff', fontFamily: 'inherit' },
};

const dis = (b: boolean) => (b ? { opacity: 0.5, cursor: 'not-allowed' } : {});
const auth = () => ({ Authorization: `Bearer ${getAuthToken()}` });
const fmtDate = (v: any) => (v ? String(v).slice(0, 10) : '—');
const fmtDT = (v: any) => (v ? String(v).replace('T', ' ').slice(0, 16) : '—');
const money = (a: any, c: any) => (a == null ? '—' : `${Number(a).toFixed(2)} ${c || ''}`.trim());

const S = (v: any) => (v == null ? '' : typeof v === 'object' ? JSON.stringify(v) : String(v));
const LS_GROUPS = 'orders_groups_open';

const COUNTRIES: Record<string, string> = { PL: 'Polska', DE: 'Niemcy', CZ: 'Czechy', SK: 'Słowacja', UA: 'Ukraina', BY: 'Białoruś', LT: 'Litwa', LV: 'Łotwa', EE: 'Estonia', GB: 'Wielka Brytania', UK: 'Wielka Brytania', IE: 'Irlandia', AT: 'Austria', BE: 'Belgia', NL: 'Holandia', FR: 'Francja', IT: 'Włochy', ES: 'Hiszpania', PT: 'Portugalia', GR: 'Grecja', SE: 'Szwecja', DK: 'Dania', FI: 'Finlandia', NO: 'Norwegia', HU: 'Węgry', RO: 'Rumunia', BG: 'Bułgaria', HR: 'Chorwacja', SI: 'Słowenia', LU: 'Luksemburg', CH: 'Szwajcaria' };
const countryName = (v: any) => { const k = String(v == null ? '' : v).trim().toUpperCase(); return COUNTRIES[k] || (v == null ? '—' : String(v)); };

const two = (a: any, b: any) => (b == null ? a : (
  <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
    <div style={{ flex: '1 1 300px', minWidth: 260 }}>{a}</div>
    <div style={{ flex: '1 1 300px', minWidth: 260 }}>{b}</div>
  </div>
));

function loadOpenGroupsInit(): any {
  try {
    const raw = localStorage.getItem(LS_GROUPS);
    if (raw === null) return 'ALL';
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v : [];
  } catch { return 'ALL'; }
}

function Ic({ d, size = 15, color = '#6b7280', title }: { d: string; size?: number; color?: string; title?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2}
      strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, display: 'block' }}>
      {title ? <title>{title}</title> : null}
      <path d={d} />
    </svg>
  );
}
const IC_CHECK = 'M20 6L9 17l-5-5';
const IC_BANKNOTE = 'M2 6v12h20V6H2zm10 6a2 2 0 110-4 2 2 0 010 4z';
const IC_TAG = 'M20.59 13.41l-9.58-9.58A2 2 0 0010.17 3H4a1 1 0 00-1 1v6.17a2 2 0 00.59 1.42l9.58 9.58a2 2 0 002.83 0l4.59-4.59a2 2 0 000-2.83z';
const IC_FILE = 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6M16 13H8M16 17H8';
const IC_RECEIPT = 'M4 2h16v20l-3-2-3 2-3-2-3 2V2zM8 7h8M8 11h8';

const DOC_META: Record<string, { label: string; color: string; d: string }> = {
  receipt: { label: 'Paragon', color: '#0f766e', d: IC_RECEIPT },
  invoice: { label: 'Faktura', color: '#7c3aed', d: IC_FILE },
  label: { label: 'Etykieta', color: '#1d4ed8', d: IC_TAG },
};
const docsOf = (o: any, t: string) => (Array.isArray(o && o.documents) ? o.documents.filter((x: any) => x && x.doc_type === t) : []);

function PayBadge({ o, small }: { o: any; small?: boolean }) {
  const st = o.is_cancelled ? { t: 'ANULOWANE', c: '#374151', bg: '#e5e7eb', b: '#9ca3af' }
    : o.is_cod ? { t: 'POBRANIE', c: '#b45309', bg: '#fffbeb', b: '#fde68a' }
      : o.is_paid ? { t: 'ZAPŁACONE', c: '#047857', bg: '#f0fdf4', b: '#bbf7d0' }
        : { t: 'NIEOPŁACONE', c: '#b91c1c', bg: '#fef2f2', b: '#fecaca' };
  return (
    <span style={{ fontSize: small ? 10.5 : 15, fontWeight: 800, letterSpacing: 0.3, borderRadius: small ? 6 : 8, padding: small ? '1px 7px' : '3px 10px', color: st.c, background: st.bg, border: `1px solid ${st.b}`, whiteSpace: 'nowrap', flexShrink: 0 }}>{st.t}</span>
  );
}

function StateIcons({ o }: { o: any }) {
  return <PayBadge o={o} small />;
}

function DocIcons({ o, onOpen, size = 15 }: { o: any; onOpen: (v: any) => void; size?: number }) {
  return (
    <span style={{ display: 'inline-flex', gap: 3, alignItems: 'center', flexShrink: 0 }}>
      {['receipt', 'invoice', 'label'].map((dt) => {
        const list = docsOf(o, dt);
        const m = DOC_META[dt];
        const active = list.length > 0;
        const need = dt === 'invoice' && !active && !!o.invoice_required;
        const title = active
          ? `${m.label}: ${list.map((x: any) => x.number || 'bez numeru').join(', ')}`
          : (need ? 'Faktura wymagana — brak dokumentu' : `Brak dokumentu: ${m.label.toLowerCase()}`);
        return (
          <span key={dt} title={title}
            onClick={(e) => { e.stopPropagation(); if (active) onOpen({ type: dt, list, order: o.order_number || ('#' + o.id), oid: o.id }); }}
            style={{ cursor: active ? 'pointer' : 'default', display: 'inline-flex', borderRadius: 5, padding: 2, background: active ? m.color + '1f' : 'transparent' }}>
            <Ic d={m.d} size={size} color={active ? m.color : (need ? '#b45309' : '#d1d5db')} />
          </span>
        );
      })}
    </span>
  );
}

function Cp({ text, children }: { text?: any; children?: React.ReactNode }) {
  const [ok, setOk] = useState(false);
  const t = text == null ? '' : String(text).trim();
  if (!t) return <>{children}</>;
  return (
    <span
      title="Kliknij, aby skopiować"
      onClick={(e) => {
        e.stopPropagation();
        try {
          navigator.clipboard.writeText(t).then(() => { setOk(true); setTimeout(() => setOk(false), 1200); });
        } catch (err) { /* ignore */ }
      }}
      style={{ cursor: 'copy', color: ok ? '#16a34a' : 'inherit', borderBottom: '1px dashed #cbd5e1' }}
    >{children == null ? t : children}{ok ? ' ✓' : null}</span>
  );
}

const PHONE_WS = RegExp(String.fromCharCode(92) + 's+', 'g');
const cleanPhone = (v: any) => (v == null ? '' : String(v).replace(PHONE_WS, ''));

class DetailBoundary extends React.Component<{ children: React.ReactNode }, { err: any; info: any }> {
  state: { err: any; info: any } = { err: null, info: null };
  static getDerivedStateFromError(err: any) { return { err: err }; }
  componentDidCatch(err: any, info: any) { this.setState({ info: info }); }
  render() {
    if (this.state.err) {
      return (
        <div style={{ background: '#fef2f2', border: '1px solid #fecdd3', borderRadius: 10, padding: 14, color: '#b91c1c' }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Błąd wyświetlania szczegółów zamówienia</div>
          <div style={{ fontSize: 12, marginBottom: 8, fontFamily: 'monospace' }}>{String((this.state.err && this.state.err.message) || this.state.err)}</div>
          <pre style={{ fontSize: 10, whiteSpace: 'pre-wrap', wordBreak: 'break-all', maxHeight: 220, overflow: 'auto', background: '#fff', padding: 8, borderRadius: 6, color: '#374151', margin: 0 }}>
            {String((this.state.info && this.state.info.componentStack) || '').slice(0, 1600)}
          </pre>
          <div style={{ fontSize: 11, color: '#6b7280', marginTop: 8 }}>Zamknij (x) i zglos ten komunikat — zamiast bialego ekranu.</div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function Orders({ onBack }: Props) {
  const [groups, setGroups] = useState<any[]>([]);
  const [statuses, setStatuses] = useState<any[]>([]);
  const [stats, setStats] = useState<any>(null);
  const [autoInfo, setAutoInfo] = useState<any>(null);
  const [orders, setOrders] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [q, setQ] = useState('');
  const [appliedQ, setAppliedQ] = useState('');
  const [statusFilter, setStatusFilter] = useState<number | null>(null);
  const [quickFilter, setQuickFilter] = useState('all');
  const [sort, setSort] = useState('ordered_desc');
  const [showFilters, setShowFilters] = useState(false);
  const [adv, setAdv] = useState({ carrier: '', payment: '', currency: '', color: '', amountMin: '', amountMax: '', dateFrom: '', dateTo: '' });
  const [nonce, setNonce] = useState(0);
  const bump = () => setNonce((n) => n + 1);

  const [openGroups, setOpenGroups] = useState<any>(loadOpenGroupsInit);

  const [selId, setSelId] = useState<number | null>(null);
  const [detail, setDetail] = useState<any>(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [note, setNote] = useState('');
  const [noteSending, setNoteSending] = useState(false);

  const [selected, setSelected] = useState<number[]>([]);
  const [bulkStatus, setBulkStatus] = useState('');
  const [bulkColor, setBulkColor] = useState('');

  const [syncing, setSyncing] = useState(false);
  const [showManualForm, setShowManualForm] = useState(false);
  const [syncReport, setSyncReport] = useState<any[] | null>(null);
  const [showStatuses, setShowStatuses] = useState(false);
  const [newStatus, setNewStatus] = useState({ name: '', color: '#3b82f6' });
  const [newGroup, setNewGroup] = useState({ name: '', sort_order: '0' });
  const [docPop, setDocPop] = useState<any>(null);
  const [editSec, setEditSec] = useState<string>('');
  useEffect(() => { setEditSec(''); setPrintMsg(null); }, [detail && detail.id]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (detail && detail.id) loadLabels(detail.id); }, [detail && detail.id, detail && docsOf(detail, 'label').length]);
  const editForm = (key: string) => (detail ? (
    <OrderEditForm key={detail.id + '-' + key} API={API} order={detail} section={key}
      onClose={() => setEditSec('')} onSaved={() => { bump(); loadStatuses(); }} />
  ) : null);
  const pen = (key: string, title?: string) => (
    <button onClick={() => setEditSec(key)} title={title || 'Edytuj tę sekcję'}
      style={{ border: '1px solid #e5e7eb', background: '#fff', borderRadius: 6, cursor: 'pointer', fontSize: 12, padding: '1px 6px', lineHeight: '18px' }}>✏️</button>
  );
  const restoreOrder = async (id: number) => {
    if (!window.confirm('Przywrócić oryginalne dane zamówienia (cofnąć wszystkie edycje)?')) return;
    try { await axios.post(`${API}/orders/${id}/restore`, {}, { headers: auth() }); bump(); } catch (e: any) { alert(e?.response?.data?.detail || 'Błąd przywracania'); }
  };
  const [docView, setDocView] = useState<any>(null);
  const [printMsg, setPrintMsg] = useState<any>(null);
  const [lbl, setLbl] = useState<any>({ loading: false, labels: [], warning: null, err: null, copied: '' });
  const loadLabels = async (oid: number) => {
    setLbl((p: any) => ({ ...p, loading: true, err: null }));
    try {
      const r = await axios.get(`${API}/orders/${oid}/labels-tracking`, { headers: auth() });
      setLbl({ loading: false, labels: (r.data && r.data.labels) || [], warning: r.data && r.data.warning, err: null, copied: '' });
    } catch (e: any) {
      setLbl({ loading: false, labels: [], warning: null, err: String((e && e.response && e.response.data && e.response.data.detail) || 'Nie udało się pobrać etykiet.'), copied: '' });
    }
  };
  const copyText = (txt: string, key: string) => {
    try { navigator.clipboard.writeText(txt).then(() => { setLbl((p: any) => ({ ...p, copied: key })); window.setTimeout(() => setLbl((p: any) => ({ ...p, copied: '' })), 1500); }); } catch (e) { /* ignore */ }
  };
  const newLabel = async (oid: number) => {
    // okno otwierane od razu (w reakcji na klikniecie), adres z serwera wstawiany po pobraniu
    const W = 1040, H = 820;
    const sx = (window.screenX != null ? window.screenX : (window as any).screenLeft) || 0;
    const sy = (window.screenY != null ? window.screenY : (window as any).screenTop) || 0;
    const ow = window.outerWidth || window.innerWidth, oh = window.outerHeight || window.innerHeight;
    const feats = 'popup,width=' + W + ',height=' + H + ',left=' + Math.max(0, Math.round(sx + (ow - W) / 2)) + ',top=' + Math.max(0, Math.round(sy + (oh - H) / 2));
    const w = window.open('', 'dosylka', feats);
    try {
      const r = await axios.get(`${API}/orders/${oid}/label-window`, { headers: auth() });
      if (w) { w.location.href = r.data.url; w.focus(); } else { const w2 = window.open(r.data.url, 'dosylka', feats); if (w2) w2.focus(); }
      const timer = window.setInterval(() => {
        if (!w || w.closed) { window.clearInterval(timer); bump(); loadLabels(oid); }
      }, 1500);
    } catch (e: any) {
      if (w) { try { w.close(); } catch (e2) { /* ignore */ } }
      setPrintMsg({ ok: false, text: '✕ ' + String((e && e.response && e.response.data && e.response.data.detail) || 'Nie udało się otworzyć Pakowalni.') });
    }
  };
  const printDoc = async (oid: number, type: string, url?: string) => {
    setPrintMsg({ ok: null, text: '⏳ Wysyłanie do drukarki…' });
    try {
      const r = await axios.post(`${API}/orders/${oid}/print`, { doc_type: type, url: url || null }, { headers: auth() });
      setPrintMsg({ ok: true, text: '✓ ' + String((r.data && r.data.message) || 'Wysłano do drukarki.') });
      bump();
    } catch (e: any) {
      setPrintMsg({ ok: false, text: '✕ ' + String((e && e.response && e.response.data && e.response.data.detail) || 'Nie udało się wysłać do drukarki.') });
    }
  };
  const printBtn = (oid: number, type: string, url?: string) => (type === 'label' || type === 'invoice') && oid ? (
    <button onClick={() => printDoc(oid, type, url)} title="Wydrukuj ponownie"
      style={{ ...s.btn, fontSize: 12, padding: '4px 10px' }}>🖨 Drukuj</button>
  ) : null;
  const printInfo = () => printMsg ? (
    <span style={{ fontSize: 12, color: printMsg.ok === true ? '#15803d' : (printMsg.ok === false ? '#b91c1c' : '#6b7280') }}>{printMsg.text}</span>
  ) : null;
  const openUrlPopup = (url: string, type: string, order?: string, number?: string, oid?: number) => {
    if (type === 'label') {
      const W = 520, H = 740;
      const sx = (window.screenX != null ? window.screenX : (window as any).screenLeft) || 0;
      const sy = (window.screenY != null ? window.screenY : (window as any).screenTop) || 0;
      const ow = window.outerWidth || window.innerWidth, oh = window.outerHeight || window.innerHeight;
      const left = Math.max(0, Math.round(sx + (ow - W) / 2)), top = Math.max(0, Math.round(sy + (oh - H) / 2));
      const w = window.open(url, 'etykieta', 'popup,width=' + W + ',height=' + H + ',left=' + left + ',top=' + top);
      if (w) { try { w.focus(); } catch (e) { /* ignore */ } return; }
    }
    setPrintMsg(null);
    setDocView({ url: url, type: type, order: order || '', number: number || '', oid: oid || 0 });
  };
  const openDoc = (v: any) => {
    if (v && v.list && v.list.length === 1 && v.list[0].url) { openUrlPopup(v.list[0].url, v.type, v.order, v.list[0].number, v.oid); return; }
    setPrintMsg(null);
    setDocPop(v);
  };

  const isOpen = (gid: any) => openGroups === 'ALL' || (Array.isArray(openGroups) && openGroups.includes(gid));
  const toggleGroup = (gid: any) => {
    const cur: any[] = openGroups === 'ALL' ? groups.map((g: any) => g.id) : (Array.isArray(openGroups) ? openGroups : []);
    const next = cur.includes(gid) ? cur.filter((x: any) => x !== gid) : [...cur, gid];
    setOpenGroups(next);
    try { localStorage.setItem(LS_GROUPS, JSON.stringify(next)); } catch { /* ignore */ }
  };

  const loadStatuses = () => {
    axios.get(`${API}/orders/status-groups`, { headers: auth() })
      .then((r) => {
        const gs = r.data?.groups || [];
        setGroups(gs);
        const flat: any[] = [];
        gs.forEach((g: any) => (g.statuses || []).forEach((st: any) => flat.push({ ...st, group_id: g.id, group_name: g.name })));
        setStatuses(flat);
      })
      .catch(() => { /* cicho */ });
  };
  const loadStats = () => {
    axios.get(`${API}/orders/stats`, { headers: auth() }).then((r) => setStats(r.data)).catch(() => { });
  };
  const loadAuto = () => {
    axios.get(`${API}/orders/autosync-info`, { headers: auth() }).then((r) => setAutoInfo(r.data)).catch(() => { });
  };

  useEffect(() => {
    loadStatuses(); loadStats(); loadAuto();
    const t = setInterval(() => { loadAuto(); loadStats(); loadStatuses(); }, 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError(null);
    const params: any = { page, per_page: perPage, sort };
    if (appliedQ.trim()) params.q = appliedQ.trim();
    if (statusFilter != null) params.status_id = statusFilter;
    if (quickFilter === 'unpaid') { params.is_paid = false; params.is_cod = false; }
    if (quickFilter === 'cod') { params.is_cod = true; }
    if (quickFilter === 'cod_open') { params.is_cod = true; params.cod_booked = false; }
    if (quickFilter === 'invoice') { params.invoice_required = true; }
    if (quickFilter === 'pickup') { params.has_pickup_point = true; }
    if (quickFilter.indexOf('c:') === 0) { params.carrier_group = quickFilter.slice(2); }
    if (adv.carrier.trim()) params.carrier = adv.carrier.trim();
    if (adv.payment) params.payment = adv.payment;
    if (adv.currency.trim()) params.currency = adv.currency.trim();
    if (adv.color) params.color = adv.color;
    const amin = parseFloat(adv.amountMin);
    if (!isNaN(amin)) params.amount_min = amin;
    const amax = parseFloat(adv.amountMax);
    if (!isNaN(amax)) params.amount_max = amax;
    if (adv.dateFrom) params.date_from = adv.dateFrom;
    if (adv.dateTo) params.date_to = adv.dateTo;
    axios.get(`${API}/orders`, { params, headers: auth() })
      .then((r) => { if (!alive) return; setOrders(r.data?.orders || []); setTotal(r.data?.total || 0); })
      .catch((e) => { if (alive) setError(e?.response?.data?.detail || 'Błąd ładowania zamówień'); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [appliedQ, statusFilter, quickFilter, adv, sort, page, perPage, nonce]);

  useEffect(() => {
    if (selId == null) { setDetail(null); return; }
    let alive = true;
    setDetailLoading(true);
    axios.get(`${API}/orders/${selId}`, { headers: auth() })
      .then((r) => { if (alive) setDetail(r.data); })
      .catch(() => { if (alive) setDetail(null); })
      .finally(() => { if (alive) setDetailLoading(false); });
    return () => { alive = false; };
  }, [selId, nonce]);

  const doSync = async () => {
    setSyncing(true);
    setSyncReport(null);
    try {
      const r = await axios.post(`${API}/orders/sync`, {}, { headers: auth(), timeout: 900000 });
      setSyncReport(r.data?.results || []);
      bump();
      loadStatuses(); loadStats(); loadAuto();
    } catch (e: any) {
      setSyncReport([{ error: e?.response?.data?.detail || `Błąd synchronizacji (${e?.message || 'sieć'})` }]);
    } finally {
      setSyncing(false);
    }
  };

  const isCancelStatus = (statusId: any) => { const st = statuses.find((x: any) => x.id === Number(statusId)); return !!st && String(st.name || '').trim() === 'Anulowane'; };
  const confirmCancel = (n: number) => window.confirm('Zmiana na „Anulowane”: dla zamówień z Allegro automat (codziennie o 5:00) złoży w Allegro wniosek o zwrot prowizji' + (n > 1 ? ' — dotyczy ' + n + ' zaznaczonych zamówień' : '') + '. Kontynuować?');
  const changeStatus = async (orderId: number, statusId: number) => {
    if (isCancelStatus(statusId) && !confirmCancel(1)) return;
    try {
      await axios.patch(`${API}/orders/${orderId}/status`, { status_id: statusId }, { headers: auth() });
      bump(); loadStatuses(); loadStats();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Błąd zmiany statusu'); }
  };

  const setMark = async (orderId: number, color: string | null) => {
    try {
      await axios.patch(`${API}/orders/${orderId}/color`, { color }, { headers: auth() });
      bump();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Błąd oznaczania'); }
  };

  const addNote = async () => {
    if (!detail || !note.trim()) return;
    setNoteSending(true);
    try {
      await axios.post(`${API}/orders/${detail.id}/notes`, { comment: note.trim() }, { headers: auth() });
      setNote('');
      bump();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Błąd dodawania notatki'); }
    finally { setNoteSending(false); }
  };

  const applyBulkStatus = async () => {
    if (!selected.length || !bulkStatus) return;
    if (isCancelStatus(bulkStatus) && !confirmCancel(selected.length)) return;
    try {
      await axios.post(`${API}/orders/bulk-status`, { order_ids: selected, status_id: Number(bulkStatus) }, { headers: auth() });
      setSelected([]); setBulkStatus('');
      bump(); loadStatuses(); loadStats();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Błąd masowej zmiany statusu'); }
  };

  const applyBulkColor = async () => {
    if (!selected.length || !bulkColor) return;
    try {
      await axios.post(`${API}/orders/bulk-color`, { order_ids: selected, color: bulkColor }, { headers: auth() });
      setSelected([]); setBulkColor('');
      bump();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Błąd masowego oznaczania'); }
  };

  const addStatus = async () => {
    if (!newStatus.name.trim()) return;
    try {
      await axios.post(`${API}/orders/statuses`, { name: newStatus.name.trim(), color: newStatus.color }, { headers: auth() });
      setNewStatus({ name: '', color: '#3b82f6' });
      loadStatuses();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Błąd dodawania statusu'); }
  };

  const saveStatus = async (stId: number, patch: any) => {
    try {
      await axios.patch(`${API}/orders/statuses/${stId}`, patch, { headers: auth() });
      loadStatuses();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Błąd zapisu statusu'); }
  };

  const delStatus = async (st: any) => {
    if (!window.confirm(`Usunąć status "${st.name}"?`)) return;
    try {
      await axios.delete(`${API}/orders/statuses/${st.id}`, { headers: auth() });
      loadStatuses();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Nie można usunąć statusu'); }
  };

  const addGroup = async () => {
    if (!newGroup.name.trim()) return;
    try {
      await axios.post(`${API}/orders/status-groups`, { name: newGroup.name.trim(), sort_order: Number(newGroup.sort_order) || 0 }, { headers: auth() });
      setNewGroup({ name: '', sort_order: '0' });
      loadStatuses();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Błąd dodawania grupy'); }
  };

  const saveGroup = async (gid: number, patch: any) => {
    try {
      await axios.patch(`${API}/orders/status-groups/${gid}`, patch, { headers: auth() });
      loadStatuses();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Błąd zapisu grupy'); }
  };

  const delGroup = async (g: any) => {
    if (!window.confirm(`Usunąć grupę "${g.name}"? Statusy wrócą do "Bez grupy".`)) return;
    try {
      await axios.delete(`${API}/orders/status-groups/${g.id}`, { headers: auth() });
      loadStatuses();
    } catch (e: any) { alert(e?.response?.data?.detail || 'Nie można usunąć grupy'); }
  };

  const sec = (title: string, children: React.ReactNode, editKey?: string) => {
    if (editKey && editSec === editKey) return editForm(editKey);
    return (
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: '12px 14px', marginBottom: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.4, flex: 1 }}>{title}</div>
          {editKey ? pen(editKey === 'pickup' ? 'delivery' : editKey) : null}
        </div>
        {children}
      </div>
    );
  };

  const kv = (k: string, v: React.ReactNode) => (
    <div style={{ display: 'flex', gap: 8, fontSize: 13, marginBottom: 4 }}>
      <span style={{ color: '#6b7280', minWidth: 90, flexShrink: 0 }}>{k}:</span>
      <span style={{ fontWeight: 500, wordBreak: 'break-all' }}>{v || '—'}</span>
    </div>
  );

  const chip = (active: boolean, color: string | undefined, children: React.ReactNode, onClick: () => void) => (
    <button onClick={onClick} style={{
      fontSize: 11, padding: '3px 10px', borderRadius: 999, cursor: 'pointer',
      border: `1px solid ${active ? (color || '#1d4ed8') : '#e5e7eb'}`,
      background: active ? (color || '#1d4ed8') : '#fff',
      color: active ? '#fff' : '#374151',
      fontWeight: active ? 600 : 400,
    }}>{children}</button>
  );

  const sideRow = (label: React.ReactNode, count: number, active: boolean, onClick: () => void, color?: string) => (
    <button onClick={onClick} style={{
      display: 'flex', alignItems: 'center', gap: 8, width: '100%', textAlign: 'left',
      padding: '6px 10px', borderRadius: 8, border: '1px solid transparent',
      background: active ? '#eff6ff' : 'transparent', cursor: 'pointer', fontSize: 12.5, color: '#374151',
    }}>
      {color ? <span style={{ width: 9, height: 9, borderRadius: '50%', background: color, flexShrink: 0 }} /> : null}
      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: active ? 600 : 400 }}>{label}</span>
      <span style={{ color: '#9ca3af', fontSize: 11 }}>{count}</span>
    </button>
  );

  const listRow = (o: any) => {
    const isSel = o.id === selId;
    const checked = selected.includes(o.id);
    const items = o.items_preview || [];
    const more = Math.max(0, (o.items_count || 0) - items.length);
    return (
      <div key={o.id} onClick={() => setSelId(o.id)} style={{ display: 'flex', gap: 10, padding: '10px 14px', border: isSel ? '1px solid #93c5fd' : '1px solid #e5e7eb', borderRadius: 10, marginBottom: 8, boxShadow: '0 1px 2px rgba(0,0,0,0.04)', cursor: 'pointer', background: isSel ? '#eff6ff' : '#fff' }}>
        <input type="checkbox" checked={checked}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => setSelected(e.target.checked ? [...selected, o.id] : selected.filter((x: number) => x !== o.id))}
          style={{ marginTop: 4 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            {o.color_mark ? <span title="Oznaczenie" style={{ width: 9, height: 9, borderRadius: '50%', background: o.color_mark, flexShrink: 0 }} /> : null}
            <span style={{ fontWeight: 700, fontSize: 13, fontFamily: 'monospace' }}>{o.order_number || ('#' + o.id)}</span>
            <span style={{ fontSize: 12, color: '#6b7280', whiteSpace: 'nowrap' }}>{o.placed_at || fmtDate(o.ordered_at)}</span>
            {o.account_name ? <span style={{ fontSize: 11, color: '#475569', background: '#f1f5f9', borderRadius: 6, padding: '1px 6px' }}>{o.account_name}</span> : null}
            {o.has_buyer_message ? <span title="Wiadomość od kupującego" style={{ fontSize: 11 }}>💬</span> : null}
            {o.notes_count > 0 ? <span title="Notatki" style={{ fontSize: 11, color: '#6b7280' }}>📝 {o.notes_count}</span> : null}
            <div style={{ flex: 1 }} />
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: o.status_color || '#d1d5db' }} />
              <span style={{ fontSize: 11, color: '#6b7280' }}>{o.status_name || '—'}</span>
            </span>
          </div>
          {items.length ? (
            <div style={{ display: 'flex', gap: 12, marginTop: 6, flexWrap: 'wrap' }}>
              {items.map((it: any, i: number) => (
                <span key={i} style={{ display: 'inline-flex', gap: 6, alignItems: 'center', maxWidth: 260 }}
                  title={`${it.name || ''} (SKU ${it.sku || '—'} · EAN ${it.ean || '—'})`}>
                  {it.image_url
                    ? <img src={it.image_url} alt="" style={{ width: 26, height: 26, objectFit: 'cover', borderRadius: 5, border: '1px solid #e5e7eb' }} />
                    : <span style={{ width: 26, height: 26, borderRadius: 5, background: '#f3f4f6', flexShrink: 0 }} />}
                  <span style={{ fontSize: 11, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{S(it.name) || '—'}</span>
                  <span style={{ fontSize: 14, fontWeight: 800, color: '#1d4ed8', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 6, padding: '1px 8px', fontFamily: 'monospace', flexShrink: 0 }}>×{S(it.quantity == null ? 1 : it.quantity)}</span>
                </span>
              ))}
              {more > 0 ? <span style={{ fontSize: 11, color: '#9ca3af', alignSelf: 'center' }}>+{more} poz.</span> : null}
            </div>
          ) : null}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}>
              {o.buyer_name || o.buyer_login || '—'}{o.buyer_city ? ` · ${o.buyer_city}` : ''}
            </span>
            <span style={{ display: 'inline-flex', gap: 3, alignItems: 'center', flexShrink: 0 }}>
              <DocIcons o={o} onOpen={openDoc} />
              <span style={{ fontSize: 13, fontWeight: 700 }}>{money(o.amount_total, o.currency)}</span>
            </span>
            <StateIcons o={o} />
          </div>
        </div>
      </div>
    );
  };

  let detailBody: React.ReactNode;
  if (detailLoading) {
    detailBody = <div style={{ padding: 40, textAlign: 'center', color: '#6b7280' }}>Ładowanie…</div>;
  } else if (!detail) {
    detailBody = <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>Brak danych zamówienia</div>;
  } else {
    const inv = detail.invoice || {};
    const ia = inv.address || {};
    const ic = ia.company || {};
    const icIds = Array.isArray(ic.ids) ? ic.ids : [];
    const nipFromIds = (icIds.find((x: any) => x && x.type === 'PL_NIP') || icIds[0] || {}).value;
    const pp = detail.pickup_point || null;
    const pa = (pp && pp.address) || {};
    detailBody = (
      <>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10, marginBottom: 10, flexWrap: 'wrap' }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 800, fontSize: 17, fontFamily: 'monospace' }}><Cp text={detail.order_number}>{detail.order_number || ('#' + detail.id)}</Cp></div>
            <div style={{ fontSize: 12, color: '#6b7280', fontFamily: 'monospace' }}>{(detail as any).source_label ? S((detail as any).source_label) : 'Allegro'}: <Cp text={S(detail.allegro_order_id)}>{S(detail.allegro_order_id) || '—'}</Cp></div>
            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
              {detail.placed_at || fmtDate(detail.ordered_at)}{detail.account_name ? ` · ${S(detail.account_name)}` : ''} · {S(detail.delivery_method_name) || '—'}
            </div>
          </div>
          <div style={{ textAlign: 'center', flexShrink: 0 }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}>
              <span style={{ fontSize: 12, color: '#6b7280' }}>Status:</span>
              <select value={detail.status_id || ''} onChange={(e) => changeStatus(detail.id, Number(e.target.value))} style={s.select}>
                {statuses.map((st) => <option key={st.id} value={st.id}>{st.name}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 6, flexWrap: 'wrap', justifyContent: 'center' }}>
              <span style={{ fontSize: 12, color: '#6b7280' }}>Oznaczenie:</span>
              {MARK_COLORS.map((c) => (
                <span key={c} onClick={() => setMark(detail.id, detail.color_mark === c ? null : c)} title={c}
                  style={{ width: 16, height: 16, borderRadius: '50%', background: c, cursor: 'pointer', display: 'inline-block', border: detail.color_mark === c ? '2px solid #111827' : '1px solid #e5e7eb' }} />
              ))}
              {detail.color_mark ? <button onClick={() => setMark(detail.id, null)} style={{ ...s.btn, fontSize: 11, padding: '2px 8px' }}>wyczyść</button> : null}
            </div>
          </div>
          <div style={{ textAlign: 'right', flexShrink: 0 }}>
            <div style={{ fontWeight: 700, fontSize: 18 }}>{money(detail.amount_total, detail.currency)}</div>
            <div style={{ fontSize: 12, color: '#6b7280', display: 'flex', gap: 6, justifyContent: 'flex-end', alignItems: 'center' }}>
              <DocIcons o={detail} onOpen={openDoc} size={16} />
              <PayBadge o={detail} />
              {pen('payment', 'Edytuj płatność')}
            </div>
          </div>
        </div>



        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 10 }}>
          <button onClick={() => setEditSec('payment')} style={{ ...s.btn, fontSize: 12 }}>✏️ Płatność</button>
          {!detail.invoice_required ? <button onClick={() => setEditSec('invoice')} style={{ ...s.btn, fontSize: 12 }}>＋ Faktura</button> : null}
          {!detail.buyer_message ? <button onClick={() => setEditSec('message')} style={{ ...s.btn, fontSize: 12 }}>＋ Wiadomość</button> : null}
          <button onClick={() => newLabel(detail.id)} title="Otwórz Pakowalnię: wybór przewoźnika, paczkomat, nadanie i wydruk nowej etykiety" style={{ ...s.btn, fontSize: 12, fontWeight: 600 }}>＋ Nowa etykieta</button>
          {docsOf(detail, 'label').some((x: any) => x.url) ? <button onClick={() => printDoc(detail.id, 'label')} title="Wydrukuj ponownie ostatnią etykietę" style={{ ...s.btn, fontSize: 12 }}>🖨 Etykieta</button> : null}
          {docsOf(detail, 'invoice').some((x: any) => x.url) ? <button onClick={() => printDoc(detail.id, 'invoice')} title="Wydrukuj ponownie ostatnią fakturę" style={{ ...s.btn, fontSize: 12 }}>🖨 Faktura</button> : null}
          {!docView && !docPop ? printInfo() : null}
          {(detail.edited_fields || []).length > 0 ? (
            <span style={{ fontSize: 12, color: '#92400e', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '3px 10px' }}>
              Edytowane w OPENkontakt ({(detail.edited_fields || []).length}) · <a href="#" onClick={(e) => { e.preventDefault(); restoreOrder(detail.id); }}>przywróć dane oryginalne</a>
            </span>
          ) : null}
        </div>

        {editSec === 'payment' || (editSec === 'invoice' && !detail.invoice_required) || (editSec === 'message' && !detail.buyer_message) ? editForm(editSec) : null}

        {sec(`Pozycje (${(detail.items || []).length})`, (
          <div>
            {(detail.items || []).map((it: any, i: number) => (
              <div key={i} style={{ display: 'flex', gap: 10, padding: '8px 0', borderBottom: '1px solid #f1f5f9', alignItems: 'center' }}>
                {it.image_url
                  ? <img src={it.image_url} alt="" style={{ width: 44, height: 44, objectFit: 'cover', borderRadius: 6, border: '1px solid #e5e7eb', flexShrink: 0 }} />
                  : <div style={{ width: 44, height: 44, borderRadius: 6, background: '#f3f4f6', flexShrink: 0 }} />}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>{S(it.name) || '—'}</div>
                  <div style={{ fontSize: 13, color: '#374151', fontFamily: 'monospace' }}>SKU <Cp text={it.sku}>{S(it.sku) || '—'}</Cp> · EAN <Cp text={it.ean}>{S(it.ean) || '—'}</Cp></div>
                </div>
                <div style={{ flexShrink: 0, display: 'flex', gap: 8, alignItems: 'center' }}>
                  <span style={{ fontSize: 14, fontWeight: 800, color: '#1d4ed8', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 6, padding: '1px 8px', fontFamily: 'monospace' }}>×{S(it.quantity)}</span>
                  <span style={{ fontSize: 13 }}>{money(it.amount, it.currency)}</span>
                </div>
              </div>
            ))}
          </div>
        ), 'items')}

        {sec(`Przesyłki i etykiety (${(lbl.labels || []).length})`, (
          <div>
            {lbl.loading ? <div style={{ fontSize: 12, color: '#6b7280' }}>⏳ Wczytywanie…</div> : null}
            {lbl.err ? <div style={{ fontSize: 12, color: '#b91c1c' }}>{lbl.err}</div> : null}
            {!lbl.loading && !lbl.err && (lbl.labels || []).length === 0 ? <div style={{ fontSize: 13, color: '#6b7280' }}>Brak etykiet. Użyj „＋ Nowa etykieta”.</div> : null}
            {(lbl.labels || []).map((l: any, i: number) => (
              <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', padding: '6px 0', borderBottom: '1px solid #f1f5f9' }}>
                <span style={{ fontSize: 13, fontFamily: 'monospace', fontWeight: 600, minWidth: 180 }}>
                  {l.number ? <Cp text={l.number}>{S(l.number)}</Cp> : <span style={{ color: '#9ca3af' }}>bez numeru</span>}
                </span>
                {l.label_url ? <button onClick={() => printDoc(detail.id, 'label', l.label_url)} title="Wydrukuj ponownie" style={{ ...s.btn, fontSize: 12, padding: '3px 9px' }}>🖨 Drukuj</button> : null}
                {l.label_url ? <button onClick={() => openUrlPopup(l.label_url, 'label', detail.order_number, l.number, detail.id)} style={{ ...s.btn, fontSize: 12, padding: '3px 9px' }}>📄 Etykieta</button> : null}
                {l.tracking_url ? <a href={l.tracking_url} target="_blank" rel="noopener noreferrer" style={{ ...s.btn, fontSize: 12, padding: '3px 9px', textDecoration: 'none', display: 'inline-block' }}>📍 Śledź przesyłkę</a> : <span style={{ fontSize: 12, color: '#9ca3af' }}>brak linku śledzenia</span>}
                {l.tracking_url ? <button onClick={() => copyText(l.tracking_url, 't' + i)} style={{ ...s.btn, fontSize: 12, padding: '3px 9px' }}>{lbl.copied === 't' + i ? '✓ Skopiowano' : '⧉ Kopiuj link'}</button> : null}
              </div>
            ))}
            {lbl.warning ? <div style={{ fontSize: 11, color: '#b45309', marginTop: 6 }}>{lbl.warning}</div> : null}
            <div style={{ marginTop: 8, display: 'flex', gap: 8, alignItems: 'center' }}>
              <button onClick={() => newLabel(detail.id)} style={{ ...s.btn, fontSize: 12, fontWeight: 600 }}>＋ Nowa etykieta</button>
              <button onClick={() => loadLabels(detail.id)} style={{ ...s.btn, fontSize: 12 }}>↻ Odśwież</button>
              {printInfo()}
            </div>
          </div>
        ))}

        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: '12px 14px', marginBottom: 10 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 8 }}>Notatki ({(detail.notes || []).length})</div>
          {(detail.notes || []).map((n: any, i: number) => (
            <div key={i} style={{ background: '#f9fafb', borderRadius: 8, padding: '8px 10px', marginBottom: 6 }}>
              <div style={{ fontSize: 11, color: '#6b7280' }}>{S(n.author_name) || '—'} · {fmtDT(n.created_at)}</div>
              <div style={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>{S(n.comment)}</div>
            </div>
          ))}
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="Dodaj notatkę (dopisywanie)…" rows={2} style={{ ...s.input, flex: 1, resize: 'vertical' }} />
            <button onClick={addNote} disabled={noteSending || !note.trim()} style={{ ...s.btnPrimary, ...dis(noteSending || !note.trim()), alignSelf: 'flex-end' }}>{noteSending ? '…' : 'Dodaj'}</button>
          </div>
        </div>

        {two(
          sec('Kupujący', (
            <div>
              {kv('Login', <Cp text={detail.buyer_login}>{S(detail.buyer_login) || '—'}</Cp>)}
              {kv('Imię i nazwisko', <Cp text={detail.buyer_name}>{S(detail.buyer_name) || '—'}</Cp>)}
              {kv('E-mail', <Cp text={detail.buyer_email}>{S(detail.buyer_email) || '—'}</Cp>)}
              {kv('Telefon', <Cp text={cleanPhone(detail.buyer_phone)}>{S(detail.buyer_phone) || '—'}</Cp>)}
            </div>
          ), 'buyer'),
          detail.invoice_required ? sec('Dane do faktury', (
            <div>
              {kv('Firma', <Cp text={ic.name}>{S(ic.name) || '—'}</Cp>)}
              {kv('NIP', <Cp text={S(ic.taxId) || S(nipFromIds)}>{S(ic.taxId) || S(nipFromIds) || '—'}</Cp>)}
              {kv('Ulica', S(ia.street))}
              {kv('Kod i miejscowość', [S(ia.zipCode) || S(ia.zip), S(ia.city)].filter(Boolean).join(' '))}
              {kv('Kraj', countryName(ia.countryCode || (ia.country || {}).code))}
            </div>
          ), 'invoice') : null
        )}

        {two(
          sec('Dostawa', (
            <div>
              {kv('Odbiorca', S(detail.delivery_name))}
              {kv('Adres', [detail.delivery_street, `${detail.delivery_zip || ''} ${detail.delivery_city || ''}`.trim()].filter(Boolean).join(', '))}
              {kv('Kraj', countryName(detail.delivery_country))}
              {kv('Metoda', S(detail.delivery_method_name))}
              {kv('Paczki', detail.package_count != null ? String(detail.package_count) : null)}
              {kv('Koszt dostawy', detail.delivery_cost != null ? money(detail.delivery_cost, detail.currency) : null)}
            </div>
          ), 'delivery'),
          pp ? sec('Punkt odbioru', (
            <div>
              {kv('Punkt', S(pp.name))}
              {kv('Kod', S(pp.id))}
              {kv('Adres', [pa.street, [pa.zipCode, pa.city].filter(Boolean).join(' ')].filter(Boolean).join(', '))}
              {pp.description ? kv('Opis', S(pp.description)) : null}
            </div>
          ), 'pickup') : null
        )}

        {detail.buyer_message ? sec('Wiadomość od kupującego', (
          <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: 10, fontSize: 13, whiteSpace: 'pre-wrap' }}>{S(detail.buyer_message)}</div>
        ), 'message') : null}

        {sec('Historia statusów', (
          <div>
            {(detail.history || []).map((h: any, i: number) => (
              <div key={i} style={{ fontSize: 12, color: '#374151', padding: '4px 0', display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <span style={{ color: '#9ca3af' }}>{fmtDT(h.created_at)}</span>
                <span>{h.from ? `${S(h.from)} → ` : ''}<b>{S(h.to)}</b></span>
                <span style={{ color: '#9ca3af' }}>({S(h.source)}{h.actor_name ? ` · ${S(h.actor_name)}` : ''})</span>
              </div>
            ))}
          </div>
        ))}
      </>
    );
  }

  const pagesTotal = Math.max(1, Math.ceil(total / perPage));
  const totalAll = stats?.total != null ? stats.total : statuses.reduce((a: number, x: any) => a + (x.orders_count || 0), 0);
  const autoTip = autoInfo?.last_auto
    ? `Ostatni cykl automatyczny: ${fmtDT(autoInfo.last_auto.at)} · +${autoInfo.last_auto.added} nowych · ${autoInfo.last_auto.updated} zaktual. · błędy: ${autoInfo.last_auto.errors}`
    : 'Auto-sync co 10 minut (usługa systemowa)';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#f8fafc', fontFamily: 'system-ui, sans-serif', color: '#111827' }}>
      <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <button onClick={onBack} style={s.btn}>← Panel</button>
        <div style={{ fontWeight: 700, fontSize: 16 }}>Zamówienia</div>
        <span style={{ fontSize: 12, color: '#6b7280' }}>{total} zam.</span>
        {autoInfo?.last_auto ? (
          <span title={autoTip} style={{ fontSize: 11, color: '#15803d', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '2px 8px' }}>
            auto {String(autoInfo.last_auto.at || '').slice(11, 16)} +{autoInfo.last_auto.added ?? 0}
          </span>
        ) : null}
        <div style={{ flex: 1 }} />
        <input value={q} onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { setAppliedQ(q.trim()); setStatusFilter(null); setQuickFilter('all'); setPage(1); } }}
          placeholder="Szukaj: nr OK, nazwisko, telefon, miasto, login, e-mail, SKU, EAN…"
          style={{ ...s.input, width: 380, maxWidth: '34vw' }} />
        <button onClick={() => { setAppliedQ(q.trim()); setStatusFilter(null); setQuickFilter('all'); setPage(1); }} style={s.btnPrimary}>Szukaj</button>
        <div style={{ flex: 1 }} />
        <button onClick={doSync} disabled={syncing} style={{ ...s.btnPrimary, ...dis(syncing) }}>{syncing ? '⏳ Synchronizacja…' : '⟳ Synchronizuj'}</button>
        <button onClick={() => setShowFilters((v) => !v)} style={s.btn}>{showFilters ? 'Ukryj filtry ▲' : 'Filtry ▼'}</button>
        <button onClick={() => setShowStatuses((v) => !v)} style={s.btn}>Statusy</button>
      </div>

      {z6ManualOrders() && showManualForm && (
        <ManualOrderForm onClose={() => setShowManualForm(false)} onCreated={() => setNonce((k: number) => k + 1)} />
      )}
      {error ? (
        <div style={{ background: '#fef2f2', color: '#b91c1c', padding: '6px 12px', fontSize: 12, borderBottom: '1px solid #fecdd3', display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{ flex: 1 }}>{error}</span>
          <button onClick={() => setError(null)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#b91c1c', fontWeight: 700 }}>✕</button>
        </div>
      ) : null}

      {syncReport ? (
        <div style={{ background: '#f0fdf4', borderBottom: '1px solid #bbf7d0', padding: '8px 16px', fontSize: 12, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          <b>Synchronizacja:</b>
          {syncReport.map((r: any, i: number) => (
            <span key={i}>
              {r.account}: {r.error
                ? <span style={{ color: '#b91c1c' }}>{r.error}</span>
                : <span style={{ color: '#15803d' }}>+{r.added} / upd {r.updated} / błędy {r.errors}</span>}
            </span>
          ))}
          <button onClick={() => setSyncReport(null)} style={{ ...s.btn, padding: '1px 8px', fontSize: 11 }}>zamknij</button>
        </div>
      ) : null}

      {showStatuses ? (
        <div style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb', padding: '12px 16px' }}>
          <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 340, maxWidth: 640 }}>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>Słownik statusów</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {statuses.map((st) => (
                  <div key={st.id} style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '6px 10px', fontSize: 13 }}>
                    <input type="color" value={st.color || '#3b82f6'} onChange={(e) => saveStatus(st.id, { color: e.target.value })} style={{ width: 26, height: 26, border: 'none', background: 'transparent', cursor: 'pointer' }} />
                    <input value={st.name}
                      onChange={(e) => setStatuses((list) => list.map((x: any) => (x.id === st.id ? { ...x, name: e.target.value } : x)))}
                      onBlur={(e) => { const v = e.target.value.trim(); if (v) saveStatus(st.id, { name: v }); }}
                      style={{ ...s.input, flex: 1, padding: '4px 8px' }} />
                    <select value={st.group_id == null ? '' : st.group_id}
                      onChange={(e) => saveStatus(st.id, { group_id: e.target.value ? Number(e.target.value) : null })}
                      style={{ ...s.select, width: 140 }}>
                      <option value="">bez grupy</option>
                      {groups.filter((g: any) => g.id != null).map((g: any) => <option key={g.id} value={g.id}>{g.name}</option>)}
                    </select>
                    <span style={{ fontSize: 11, color: '#6b7280', flexShrink: 0 }}>{st.orders_count} zam.</span>
                    {st.is_default
                      ? <span style={{ fontSize: 10, background: '#eff6ff', color: '#1d4ed8', borderRadius: 8, padding: '2px 6px', flexShrink: 0 }}>domyślny</span>
                      : <button onClick={() => saveStatus(st.id, { is_default: true })} style={{ ...s.btn, fontSize: 11, padding: '2px 6px', flexShrink: 0 }}>ustaw domyślny</button>}
                    <button onClick={() => delStatus(st)} title="Usuń" style={{ ...s.btn, fontSize: 11, padding: '2px 6px', color: '#b91c1c', flexShrink: 0 }}>✕</button>
                  </div>
                ))}
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <input type="color" value={newStatus.color} onChange={(e) => setNewStatus((x) => ({ ...x, color: e.target.value }))} style={{ width: 26, height: 26, border: 'none', background: 'transparent', cursor: 'pointer' }} />
                  <input value={newStatus.name} onChange={(e) => setNewStatus((x) => ({ ...x, name: e.target.value }))} placeholder="Nowy status…" style={{ ...s.input, flex: 1 }} />
                  <button onClick={addStatus} disabled={!newStatus.name.trim()} style={{ ...s.btnPrimary, ...dis(!newStatus.name.trim()) }}>Dodaj</button>
                </div>
              </div>
            </div>
            <div style={{ flex: 1, minWidth: 280, maxWidth: 460 }}>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>Grupy statusów (akordeon lewej kolumny)</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {groups.filter((g: any) => g.id != null).map((g: any) => (
                  <div key={g.id} style={{ display: 'flex', gap: 8, alignItems: 'center', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '6px 10px', fontSize: 13 }}>
                    <input value={g.name}
                      onChange={(e) => setGroups((list) => list.map((x: any) => (x.id === g.id ? { ...x, name: e.target.value } : x)))}
                      onBlur={(e) => { const v = e.target.value.trim(); if (v) saveGroup(g.id, { name: v }); }}
                      style={{ ...s.input, flex: 1, padding: '4px 8px' }} />
                    <input type="number" value={g.sort_order}
                      onChange={(e) => setGroups((list) => list.map((x: any) => (x.id === g.id ? { ...x, sort_order: Number(e.target.value) || 0 } : x)))}
                      onBlur={(e) => saveGroup(g.id, { sort_order: Number(e.target.value) || 0 })}
                      title="Kolejność"
                      style={{ ...s.input, width: 64, padding: '4px 8px' }} />
                    <span style={{ fontSize: 11, color: '#6b7280', flexShrink: 0 }}>{g.statuses_count} statusów</span>
                    <button onClick={() => delGroup(g)} title="Usuń grupę" style={{ ...s.btn, fontSize: 11, padding: '2px 6px', color: '#b91c1c', flexShrink: 0 }}>✕</button>
                  </div>
                ))}
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <input value={newGroup.name} onChange={(e) => setNewGroup((x) => ({ ...x, name: e.target.value }))} placeholder="Nowa grupa…" style={{ ...s.input, flex: 1 }} />
                  <input type="number" value={newGroup.sort_order} onChange={(e) => setNewGroup((x) => ({ ...x, sort_order: e.target.value }))} title="Kolejność" style={{ ...s.input, width: 64 }} />
                  <button onClick={addGroup} disabled={!newGroup.name.trim()} style={{ ...s.btnPrimary, ...dis(!newGroup.name.trim()) }}>Dodaj</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {showFilters ? (
        <div style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb', padding: '12px 16px', display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end', fontSize: 12 }}>
          <label>Dostawa<br />
            <input value={adv.carrier} onChange={(e) => { setAdv((a) => ({ ...a, carrier: e.target.value })); setPage(1); }} placeholder="np. InPost" style={{ ...s.input, width: 130, marginTop: 2 }} />
          </label>
          <label>Płatność<br />
            <select value={adv.payment} onChange={(e) => { setAdv((a) => ({ ...a, payment: e.target.value })); setPage(1); }} style={{ ...s.select, width: 150, marginTop: 2 }}>
              <option value="">wszystkie</option>
              <option value="ONLINE">ONLINE</option>
              <option value="CASH_ON_DELIVERY">pobranie</option>
            </select>
          </label>
          <label>Konto<br />
            <select value={adv.currency} onChange={(e) => { setAdv((a) => ({ ...a, currency: e.target.value })); setPage(1); }} style={{ ...s.select, width: 90, marginTop: 2 }}>
              <option value="">—</option>
              <option value="PLN">PLN</option>
              <option value="EUR">EUR</option>
            </select>
          </label>
          <label>Oznaczenie<br />
            <select value={adv.color} onChange={(e) => { setAdv((a) => ({ ...a, color: e.target.value })); setPage(1); }} style={{ ...s.select, width: 120, marginTop: 2 }}>
              <option value="">wszystkie</option>
              <option value="none">brak</option>
              {MARK_COLORS.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </label>
          <label>Kwota od<br />
            <input type="number" value={adv.amountMin} onChange={(e) => { setAdv((a) => ({ ...a, amountMin: e.target.value })); setPage(1); }} style={{ ...s.input, width: 90, marginTop: 2 }} />
          </label>
          <label>Kwota do<br />
            <input type="number" value={adv.amountMax} onChange={(e) => { setAdv((a) => ({ ...a, amountMax: e.target.value })); setPage(1); }} style={{ ...s.input, width: 90, marginTop: 2 }} />
          </label>
          <label>Data od<br />
            <input type="date" value={adv.dateFrom} onChange={(e) => { setAdv((a) => ({ ...a, dateFrom: e.target.value })); setPage(1); }} style={{ ...s.input, width: 140, marginTop: 2 }} />
          </label>
          <label>Data do<br />
            <input type="date" value={adv.dateTo} onChange={(e) => { setAdv((a) => ({ ...a, dateTo: e.target.value })); setPage(1); }} style={{ ...s.input, width: 140, marginTop: 2 }} />
          </label>
          <button onClick={() => { setAdv({ carrier: '', payment: '', currency: '', color: '', amountMin: '', amountMax: '', dateFrom: '', dateTo: '' }); setPage(1); }} style={s.btn}>Wyczyść filtry</button>
        </div>
      ) : null}

      <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '8px 16px', display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
        {z6ManualOrders() ? (
          <button onClick={() => setShowManualForm(true)} style={{ padding: '4px 12px', borderRadius: 999, border: '1px solid #15803d', background: '#15803d', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>+ Dodaj zamówienie</button>
        ) : null}
        {['UPS', 'GLS', 'One', 'DHL', 'DPD', 'Orlen', 'InPost', 'Poczta Polska'].map((cg) => (
          <React.Fragment key={cg}>
            {chip(quickFilter === 'c:' + cg, '#0f766e', `${cg} (${(stats && stats.carriers && stats.carriers[cg] != null) ? stats.carriers[cg] : 0})`, () => { setQuickFilter(quickFilter === 'c:' + cg ? 'all' : 'c:' + cg); setPage(1); })}
          </React.Fragment>
        ))}
        <div style={{ flex: 1 }} />
        <label style={{ fontSize: 11, color: '#6b7280', display: 'inline-flex', gap: 6, alignItems: 'center' }}>
          Sortuj:
          <select value={sort} onChange={(e) => { setSort(e.target.value); setPage(1); }} style={{ ...s.select, padding: '4px 6px', fontSize: 12 }}>
            <option value="ordered_desc">najnowsze</option>
            <option value="ordered_asc">najstarsze</option>
            <option value="amount_desc">kwota malejąco</option>
            <option value="amount_asc">kwota rosnąco</option>
            <option value="number_desc">numer malejąco</option>
            <option value="number_asc">numer rosnąco</option>
            <option value="paid_desc">data zapłaty</option>
            <option value="cod_desc">księgowanie pobrania</option>
          </select>
        </label>
      </div>

      <div style={{ flex: 1, display: 'flex', minHeight: 0 }}>
        <div style={{ width: 250, minWidth: 220, borderRight: '1px solid #e5e7eb', display: 'flex', flexDirection: 'column', background: '#fff', overflowY: 'auto' }}>
          <div style={{ padding: '10px 12px 4px', fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.4 }}>Statusy</div>
          <div style={{ padding: '4px 8px 12px' }}>
            <div style={{ marginBottom: 4 }}>
              {sideRow('Wszystkie', totalAll, statusFilter == null, () => { setStatusFilter(null); setQ(''); setAppliedQ(''); setPage(1); })}
            </div>
            {groups.map((g: any) => {
              const gid = g.id;
              const open = isOpen(gid);
              return (
                <div key={gid == null ? 'nogrp' : gid} style={{ marginBottom: 2 }}>
                  <div onClick={() => toggleGroup(gid)} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '7px 10px', cursor: 'pointer', fontSize: 12, fontWeight: 700, color: '#374151', background: '#f8fafc', borderRadius: 8 }}>
                    <span style={{ fontSize: 10, color: '#6b7280' }}>{open ? '▼' : '▶'}</span>
                    <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{g.name}</span>
                    <span style={{ color: '#9ca3af', fontSize: 11, fontWeight: 400 }}>{g.orders_count}</span>
                  </div>
                  {open ? (g.statuses || []).map((st: any) => (
                    <div key={st.id} style={{ padding: '1px 0 1px 6px' }}>
                      {sideRow(st.name, st.orders_count, statusFilter === st.id, () => { setStatusFilter(statusFilter === st.id ? null : st.id); setQ(''); setAppliedQ(''); setPage(1); }, st.color)}
                    </div>
                  )) : null}
                </div>
              );
            })}
          </div>
        </div>

        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', background: '#fff' }}>
          {selected.length > 0 ? (
            <div style={{ background: '#eff6ff', borderBottom: '1px solid #bfdbfe', padding: '8px 12px', display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', fontSize: 12 }}>
              <b>Zaznaczono {selected.length}</b>
              <select value={bulkStatus} onChange={(e) => setBulkStatus(e.target.value)} style={{ ...s.select, width: 160 }}>
                <option value="">zmień status…</option>
                {statuses.map((st) => <option key={st.id} value={st.id}>{st.name}</option>)}
              </select>
              <button onClick={applyBulkStatus} disabled={!bulkStatus} style={{ ...s.btnPrimary, ...dis(!bulkStatus) }}>OK</button>
              <select value={bulkColor} onChange={(e) => setBulkColor(e.target.value)} style={{ ...s.select, width: 120 }}>
                <option value="">oznacz…</option>
                {MARK_COLORS.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
              <button onClick={applyBulkColor} disabled={!bulkColor} style={{ ...s.btnPrimary, ...dis(!bulkColor) }}>OK</button>
              <div style={{ flex: 1 }} />
              <button onClick={() => setSelected([])} style={{ ...s.btn, padding: '4px 8px' }}>Odznacz</button>
            </div>
          ) : null}

          {orders.length > 0 ? (
            <div style={{ padding: '6px 14px', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#374151', background: '#fff' }}>
              <input type="checkbox" checked={orders.every((o: any) => selected.includes(o.id))}
                onChange={(e) => {
                  const ids = orders.map((o: any) => o.id);
                  setSelected(e.target.checked ? Array.from(new Set([...selected, ...ids])) : selected.filter((x: number) => !ids.includes(x)));
                }} style={{ cursor: 'pointer' }} />
              <span>Zaznacz wszystkie na tej stronie ({orders.length})</span>
              {selected.length > 0 ? <span style={{ color: '#6b7280' }}>· zaznaczono łącznie: {selected.length}</span> : null}
            </div>
          ) : null}
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {loading && orders.length === 0 ? (
              <div style={{ padding: 30, textAlign: 'center', color: '#6b7280' }}>Ładowanie…</div>
            ) : orders.length === 0 ? (
              <div style={{ padding: 30, textAlign: 'center', color: '#9ca3af' }}>Brak zamówień dla tych kryteriów</div>
            ) : (
              orders.map(listRow)
            )}
          </div>

          <div style={{ borderTop: '1px solid #e5e7eb', padding: '8px 12px', display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
            <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page <= 1} style={{ ...s.btn, ...dis(page <= 1) }}>←</button>
            <span>{total ? `${(page - 1) * perPage + 1}–${Math.min(page * perPage, total)} z ${total}` : '0'} · str. {page}/{pagesTotal}</span>
            <button onClick={() => setPage((p) => p + 1)} disabled={page * perPage >= total} style={{ ...s.btn, ...dis(page * perPage >= total) }}>→</button>
            <div style={{ flex: 1 }} />
            <select value={perPage} onChange={(e) => { setPerPage(Number(e.target.value)); setPage(1); }} style={{ ...s.select, width: 84 }}>
              {[25, 50, 100].map((n) => <option key={n} value={n}>{n} / str.</option>)}
            </select>
          </div>
        </div>
      </div>


      {docView ? (
        <div onClick={() => setDocView(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 85, padding: '3vh 16px', overflowY: 'auto' }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: docView.type === 'label' ? 560 : (docView.type === 'receipt' ? 360 : 900), padding: '12px 14px', boxShadow: '0 20px 50px rgba(0,0,0,0.25)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
              {DOC_META[docView.type] ? <Ic d={DOC_META[docView.type].d} color={DOC_META[docView.type].color} size={18} /> : null}
              <div style={{ fontWeight: 700, fontSize: 15, flex: 1 }}>{DOC_META[docView.type] ? DOC_META[docView.type].label : 'Dokument'}{docView.order ? ' · ' + S(docView.order) : ''}{docView.number ? ' · ' + S(docView.number) : ''}</div>
              {printInfo()}
              {printBtn(docView.oid, docView.type, docView.url)}
              <a href={docView.url} target="_blank" rel="noopener noreferrer" title="Otwórz w nowej karcie" style={{ fontSize: 12, color: '#6b7280' }}>↗ nowa karta</a>
              <button onClick={() => setDocView(null)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280' }}>✕</button>
            </div>
            <iframe src={docView.url} title="Podgląd dokumentu"
              style={{ width: '100%', height: docView.type === 'label' ? 'min(740px, 84vh)' : (docView.type === 'receipt' ? '34vh' : '84vh'), border: '1px solid #e5e7eb', borderRadius: 8, background: '#f9fafb' }} />
          </div>
        </div>
      ) : null}
      {docPop ? (
        <div onClick={() => setDocPop(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 80, padding: 16 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 440, padding: '16px 18px', boxShadow: '0 20px 50px rgba(0,0,0,0.25)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
              <Ic d={DOC_META[docPop.type].d} color={DOC_META[docPop.type].color} size={18} />
              <div style={{ fontWeight: 700, fontSize: 15, flex: 1 }}>{DOC_META[docPop.type].label} · {docPop.order}</div>
              <button onClick={() => setDocPop(null)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280' }}>✕</button>
            </div>
            {printMsg ? <div style={{ marginBottom: 8 }}>{printInfo()}</div> : null}
            {(docPop.list || []).map((d: any, i: number) => (
              <div key={i} style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 10px', marginBottom: 8 }}>
                {kv('Numer', <Cp text={d.number}>{S(d.number) || '—'}</Cp>)}
                {d.issued_at ? kv('Data wystawienia', fmtDate(d.issued_at)) : null}
                {d.url
                  ? <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginTop: 4 }}>
                      <button onClick={() => openUrlPopup(d.url, docPop.type, docPop.order, d.number, docPop.oid)} style={s.btnPrimary}>Otwórz dokument</button>
                      {printBtn(docPop.oid, docPop.type, d.url)}
                      {d.tracking_url ? <a href={d.tracking_url} target="_blank" rel="noopener noreferrer" style={{ ...s.btn, fontSize: 12, padding: '4px 10px', textDecoration: 'none', display: 'inline-block' }}>📍 Śledź przesyłkę</a> : null}
                    </div>
                  : <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>Plik dokumentu nie został przekazany — zapisany jest tylko numer.</div>}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {selId != null ? (
        <div onClick={() => setSelId(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '3vh 16px', zIndex: 60, overflowY: 'auto' }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, width: '100%', maxWidth: 880, padding: '14px 18px 18px', boxShadow: '0 20px 50px rgba(0,0,0,0.25)', marginBottom: '3vh' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={() => setSelId(null)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280' }}>✕</button>
            </div>
            <DetailBoundary key={selId}>{detailBody}</DetailBoundary>
          </div>
        </div>
      ) : null}
    </div>
  );
}
